//1.Import
import "@lottiefiles/lottie-player";
import Layout from '../Layout';
//2.Initialization

const layout=new Layout();
//3.Events
window.addEventListener('DOMContentLoaded', function() {
       //your code here
});
//4. Functions

